module.exports = __webpack_public_path__ + "static/edwards-4ba82140877ca7c7b64e947448e1ae04.jpg";